/**
 * reminders-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { Reminder } from "../../../watchlist/reminder";
import { validateAs, validateFor, validateOpaqueID }
    from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link RemindersResponse} lists all current reminders the user has set
 * (or have been assigned to the user). It is received during the initial
 * message bundle, or after edits to the resource.
 */
@validateFor(MessageTag.RSP_REMINDERS)
export class RemindersResponse extends IncomingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.RSP_REMINDERS;

    @validateOpaqueID()
    public objectId : number;

    @validateAs({array: "object"})
    public notificationList : Reminder[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/reminders/reminders-response.ts